export class MyContainerDeviceDedicatedSupplyMetadata {
    public amount: number;
    public addTo5stepOrderList: boolean;


    constructor( amount =  null) {
        this.amount = amount;
        this.addTo5stepOrderList = false;
    }
}


